import React from "react";

const SECTORS = [
    {
        code: "S.01",
        letter: "S",
        title: "Space",
        desc: "Launch, satellites, orbital infrastructure, microgravity manufacturing.",
    },
    {
        code: "S.02",
        letter: "R",
        title: "Robotics",
        desc: "Autonomous systems, humanoids, embodied intelligence.",
    },
    {
        code: "S.03",
        letter: "E",
        title: "Energy",
        desc: "Nuclear microreactors, fusion, long-duration storage.",
    },
    {
        code: "S.04",
        letter: "D",
        title: "Defense",
        desc: "Autonomous defense, dual-use technology, national security.",
    },
    {
        code: "S.05",
        letter: "Q",
        title: "Deep Computing",
        desc: "Quantum, next-gen silicon, photonic compute.",
    },
    {
        code: "S.06",
        letter: "X",
        title: "Frontier X",
        desc: "Longevity, collectibles — the categories that don't fit a box.",
    },
];

export default function SectorsGrid() {
    return (
        <section id="sectors" className="relative z-10" data-testid="sectors-section">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-16 md:pt-24">
                <div className="flex items-end justify-between mb-8">
                    <div>
                        <div className="overline-cobalt mb-3">§ Where we focus</div>
                        <h2
                            className="font-display"
                            style={{
                                fontSize: "clamp(36px, 5vw, 64px)",
                                lineHeight: 0.98,
                                color: "var(--ink)",
                            }}
                        >
                            Six active{" "}
                            <span
                                style={{
                                    fontFamily: "'Fraunces', serif",
                                    fontStyle: "italic",
                                    fontWeight: 400,
                                    color: "var(--cobalt)",
                                }}
                            >
                                sectors.
                            </span>
                        </h2>
                    </div>
                    <div className="overline hidden md:block">[06 / 06]</div>
                </div>

                <div
                    className="grid grid-cols-1 md:grid-cols-3 gap-px"
                    style={{ background: "var(--rule)", border: "1px solid var(--rule)" }}
                >
                    {SECTORS.map((s) => (
                        <article
                            key={s.code}
                            className="group relative p-7 md:p-9 flex flex-col justify-between min-h-[220px]"
                            style={{ background: "var(--panel)" }}
                            data-testid={`sector-${s.code}`}
                        >
                            <div className="flex items-start justify-between">
                                <span
                                    className="overline-cobalt"
                                    style={{ letterSpacing: "0.28em" }}
                                >
                                    [{s.code}]
                                </span>
                                <span
                                    style={{
                                        fontFamily: "'Fraunces', serif",
                                        fontStyle: "italic",
                                        fontWeight: 400,
                                        fontSize: 56,
                                        lineHeight: 0.9,
                                        color: "var(--rule)",
                                        transition: "color .3s ease",
                                    }}
                                    className="group-hover:!text-[var(--cobalt)]"
                                >
                                    {s.letter}
                                </span>
                            </div>
                            <div className="mt-8">
                                <h3
                                    style={{
                                        fontFamily: "'Inter', sans-serif",
                                        fontWeight: 900,
                                        fontSize: 28,
                                        color: "var(--ink)",
                                        letterSpacing: "-0.025em",
                                        lineHeight: 1,
                                    }}
                                >
                                    {s.title}
                                </h3>
                                <p
                                    style={{
                                        color: "var(--ink-2)",
                                        fontSize: 13,
                                        lineHeight: 1.55,
                                        marginTop: 8,
                                        maxWidth: "22rem",
                                    }}
                                >
                                    {s.desc}
                                </p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
